
export class BasicEntity {
businessUnitCode: string;
createBy: string;
createTime: number | null;
crudChecked: boolean | null;
crudError: boolean | null;
deleted: boolean | null;
deprecated: boolean | null;
domain: string;
hasChange: string;
id: number | null;
maintenanceFlag: string;
operation: string;
precursor: Object;
revisionNumber: number | null;
shortCode: string;
source: string;
uid: string;
updateBy: string;
updateTime: number | null;
version: number | null;
}

